//Search
export const ROLE_SEARCH_START_LOADING = "ROLE_SEARCH_START_LOADING";
export const ROLE_SEARCH_END_LOADING = "ROLE_SEARCH_END_LOADING";
export const ROLE_SEARCH_LOADED = "ROLE_SEARCH_LOADED";
export const SET_ROLE_FILTER = "SET_ROLE_FILTER";

//Edit
export const ROLE_START_LOADING = "ROLE_START_LOADING";
export const ROLE_END_LOADING = "ROLE_END_LOADING";
export const ROLE_LOADED = "ROLE_LOADED";
